"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SettingsOutlined_1 = __importDefault(require("@mui/icons-material/SettingsOutlined"));
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var react_1 = require("react");
var LoadingBravasButton_1 = __importDefault(require("../LoadingBravasButton"));
function EditAndSaveButtons(_a) {
    var isLoading = _a.isLoading, cancelBtnTitle = _a.cancelBtnTitle, cancelBtnAction = _a.cancelBtnAction, saveBtnTitle = _a.saveBtnTitle, saveBtnAction = _a.saveBtnAction, editBtnTitle = _a.editBtnTitle, editBtnAction = _a.editBtnAction, forceEditMode = _a.forceEditMode, forceNotEditMode = _a.forceNotEditMode, disabled = _a.disabled;
    var _b = __read((0, react_1.useState)(forceEditMode || false), 2), edit = _b[0], setEdit = _b[1];
    return ((0, jsx_runtime_1.jsx)(system_1.Stack, __assign({ direction: "row", spacing: 2 }, { children: edit && !forceNotEditMode ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, __assign({ onClick: function () {
                        cancelBtnAction();
                        setEdit(false);
                    }, variant: "outlined", color: "darkGrey" }, { children: cancelBtnTitle })), (0, jsx_runtime_1.jsx)(LoadingBravasButton_1.default, __assign({ disabled: disabled, type: "submit", variant: "contained", loading: isLoading, onClick: function () {
                        saveBtnAction();
                        setEdit(false);
                    } }, { children: saveBtnTitle }))] })) : ((0, jsx_runtime_1.jsx)(material_1.Button, __assign({ startIcon: (0, jsx_runtime_1.jsx)(SettingsOutlined_1.default, {}), variant: "contained", size: "large", sx: {
                width: 'auto',
            }, onClick: function () {
                editBtnAction();
                setEdit(true);
            } }, { children: (0, jsx_runtime_1.jsx)(system_1.Stack, __assign({ display: "inline-flex", whiteSpace: "nowrap" }, { children: editBtnTitle })) }))) })));
}
exports.default = EditAndSaveButtons;
EditAndSaveButtons.defaultProps = {
    forceEditMode: false,
    forceNotEditMode: false,
    disabled: false,
};
//# sourceMappingURL=EditAndSaveButtons.js.map